import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据 
export const fetchData = query => { 
    var list = request({
        url: 'comGoodsGroup/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
}; 
export const changeStatus = query => {  
    var list = request({
        url: 'comGoodsGroup/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
}; 

export const changeStatus2 = query => {  
    var list = request({
        url: 'comGoodsGroup/changeMaster.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
}; 
export const changeVal = query => {  
    var list = request({
        url: 'comGoodsGroup/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 

 
 




